import React from "react";
import SortDropdown from "../../../components/SortDropdown";

export function LookbookFilterDropdown({
  onChange,
  options,
  value,
  placeholder,
  className = "lb-filter-dropdown__control products-sort",
}) {
  return (
    <div className="lb-filter-dropdown">
      <SortDropdown
        onChange={onChange}
        options={options}
        value={value}
        placeholder={placeholder}
        className={className}
      />
      <span className="lb-filter-dropdown__chevron" aria-hidden="true">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
          <path
            d="M3 5l4 4 4-4"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
    </div>
  );
}
